
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { useEffect, useState } from 'react';
import { store } from './redux/store';
import { router } from './routes/router';
import {
  fetchRestaurantsRequest,
  
} from './redux/slices/restaurantSlice';
import { useAppDispatch, useAppSelector } from './redux/hooks';
import Loader from './components/Loader';
// import EmptyState from './components/EmptyState';
import { TitleUpdater } from './components';
import { AIImageGenerationDrawer } from './components/AIImageGenerationDrawer';
import { AITextGenerationDrawer } from './components/AITextGenerationDrawer';
import { useGlobalAIDrawers } from './hooks/useGlobalAIDrawers';
import { shouldSkipApiCalls } from './utils/appConfig';
import { useAppStyle } from './hooks/useAppStyle';
// import { isSiteContentEmpty } from './utils/emptyStateUtils';
function AppContent() {
  const dispatch = useAppDispatch();
  
  // Initialize app-wide styling (replaces StyleProvider)
  useAppStyle();
  const {loading: restaurantLoading } = useAppSelector(state => state.restaurant);
  const {fetchLoading: siteContentLoading, data: siteContent } = useAppSelector(
    state => state.siteContent
  );

 const [appLoading,setAppLoading] = useState(false)
  const {
    imageDrawer,
    textDrawer,
    closeImageDrawer,
    closeTextDrawer
  } = useGlobalAIDrawers();

  useEffect(() => {
    dispatch(fetchRestaurantsRequest());
  }, [dispatch]);

  useEffect(() => {
    // If in preview mode, don't show loader for API-related loading states
    if (shouldSkipApiCalls()) {
      setAppLoading(false);
    } else {
      setAppLoading(siteContentLoading || restaurantLoading);
    }
  }, [siteContentLoading, restaurantLoading, siteContent]);

  // Check for empty site content and show full-screen empty state
  // const showEmptyState = !appLoading && (!siteContent || isSiteContentEmpty(siteContent));

  // Debug logging removed for production

  // if (showEmptyState) {
  //   console.log('[App.tsx] Showing EmptyState component');
  //   return (
  //     <EmptyState
  //       title="We're preparing something great!"
  //       message="This page isn't ready yet. Please check back soon."
  //     />
  //   );
  // }

  return (
    <>
      <TitleUpdater />
      <RouterProvider router={router} />
      <Loader
        message="Loading your application. Please wait..."
        loading={appLoading}
      />

      {/* Global AI Drawers - Best Practices Pattern */}
      <AIImageGenerationDrawer
        isOpen={!!imageDrawer}
        onClose={closeImageDrawer}
        onImageSelect={imageDrawer?.onImageSelect || (() => { })}
        defaultPrompt={imageDrawer?.prompt}
      />

      <AITextGenerationDrawer
        isOpen={!!textDrawer}
        onClose={closeTextDrawer}
        onTextSelect={textDrawer?.onTextSelect || (() => { })}
        defaultPrompt={textDrawer?.prompt}
        currentFieldContent={textDrawer?.currentContent}
      />
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
